import { getAnnotation, mapNodes } from '@/mgnl/utils/magnolia.js';
import { EditorContextService, Constants } from '@magnolia/frontend-helpers-base';
import { defineElement, TemplateElement } from '@webtides/element-js';
import './mgnl-editable-comment.js';
import './mgnl-editable-component.js';

class MgnlEditableArea extends TemplateElement {
    properties() {
        return {
            content: null,
            mgnlContext: null,
        };
    }

    injectProperties() {
        return { config: null, mgnlContext: null, templateAnnotations: null };
    }

    get annotation() {
        return getAnnotation(this.templateAnnotations, this.content);
    }

    renderTemplate() {
        const container = this.getRoot();

        while (container.firstChild) {
            container.removeChild(container.firstChild);
        }

        const fragment = document.createDocumentFragment();
        //
        if (this.annotation) {
            const comment = document.createComment(this.annotation);
            fragment.appendChild(comment);
            EditorContextService.refresh(0);
        }

        const nodes = mapNodes(this.content);
        nodes.forEach((nodeContent) => {
            const editableComponent = document.createElement('mgnl-editable-component');
            editableComponent.content = nodeContent;
            fragment.appendChild(editableComponent);
        });

        if (this.annotation) {
            const comment = document.createComment(Constants.END_AREA_COMMENT);
            fragment.appendChild(comment);
        }

        container.appendChild(fragment);
    }
}

defineElement('mgnl-editable-area', MgnlEditableArea);
